import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-fade';

// 1枚あたりの静止時間(ms)。フェード時間と合わせて1枚 7000ms になる
const HERO_DELAY = 5200;
// クロスフェードにかける時間(ms)。SCSS の $hero-fade-duration と揃えること
const HERO_SPEED = 1800;

// メインビジュアルのフェードスライダー。
// 動画の代わりなので操作UIは持たせず、自動再生のみで流し続ける。
const homeHero = () => {
    const el = document.querySelector('.js-hero-swiper');
    if (!el) return;

    // 視差効果を減らす設定の環境では自動切り替えを行わず、1枚目のみ表示する
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    new Swiper(el, {
        modules: [Autoplay, EffectFade],
        effect: 'fade',
        // 下のスライドを不透明のまま残し、上のスライドだけをフェードさせる。
        // true にすると切り替えの中間で両方が半透明になり背景が透けてしまう
        fadeEffect: { crossFade: false },
        loop: true,
        speed: HERO_SPEED,
        allowTouchMove: false,
        simulateTouch: false,
        autoplay: {
            delay: HERO_DELAY,
            disableOnInteraction: false,
        },
    });
};

export default homeHero;
